import IAnswer from '../../models/IAnswer';
import IAssessment from '../../models/IAssessment';
import IAssessmentElement from '../../models/IAssessmentElement';
import IAssessmentPage from '../../models/IAssessmentPage';

export enum ActionType 
	{
	SetAnswer = 'SET_ANSWER',
	SetAssessment = 'SET_ASSESSMENT',
	SetPage = 'SET_PAGE',
	UpdateAssessmentElement = 'UPDATE_ASSESSMENT_ELEMENT'
}

type SetAnswerState = {
	type: ActionType.SetAnswer;
	payload: IAnswer;
}

type SetAssessmentState = {
	type: ActionType.SetAssessment;
	payload: IAssessment | null;
}

type SetPageState = {
	type: ActionType.SetPage;
	payload: IAssessmentPage | null;
}

type UpdateAssessmentElementState = {
	type: ActionType.UpdateAssessmentElement;
	payload: IAssessmentElement;
}

export type Actions = SetAnswerState | SetAssessmentState | SetPageState | UpdateAssessmentElementState;

export const setAnswer = (payload: IAnswer): SetAnswerState => ({
	type: ActionType.SetAnswer,
	payload
});

export const setAssessment = (payload: IAssessment | null): SetAssessmentState => ({
	type: ActionType.SetAssessment,
	payload
});

export const setPage = (payload: IAssessmentPage | null): SetPageState => ({
	type: ActionType.SetPage,
	payload
});

export const updateAssessmentElement = (payload: IAssessmentElement): UpdateAssessmentElementState => ({
	type: ActionType.UpdateAssessmentElement,
	payload
});
